// frontend/src/api/fetchData.jsx
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000/api';


async function fetchData(endpoint, method = 'GET', body = null, options = {}) {
    let url = `${API_BASE_URL}${endpoint}`;

    if (method === 'GET') {

        const separator = url.includes('?') ? '&' : '?';
        url += `${separator}_cacheBust=${new Date().getTime()}`;
    }

    const config = {
        method: method,
        headers: {
            'Content-Type': 'application/json',
        },
        ...(body && method !== 'GET' && { body: JSON.stringify(body) }),
        ...options
    };

    try {
        const response = await fetch(url, config);

        if (!response.ok) {
            const errorText = await response.text().catch(() => "Не удалось прочитать текст ошибки.");

            try {
                const errorData = JSON.parse(errorText);
                return { status: 'error', message: errorData.message || `HTTP status ${response.status}: ${errorText}` };
            } catch (jsonParseError) {
                return { status: 'error', message: `HTTP status ${response.status}: ${errorText}` };
            }
        }

        const text = await response.text();
        if (text.length === 0) {
            return { status: 'success', data: {} };
        }

        const parsedData = JSON.parse(text);
        return parsedData;
    } catch (error) {
        return { status: 'error', message: error.message || "Ошибка парсинга или сети в fetchData." };
    }
}

export default fetchData;